var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinLateComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 53",
    enableBackground: "new 0 0 55 53",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Late Complete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Late-Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 78,
    height: 74,
    xlinkHref: "145333E3481A3FF0.png",
    transform: "matrix(1 0 0 1 -11.6943 -10.707)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    fill: "#FFFFFF",
    stroke: "#FF5670",
    strokeWidth: 2.4,
    d: "M9.822,7h34.756c2.674,0,4.822,2.104,4.822,4.722 v24.396c0,2.618-2.135,4.656-4.822,4.656H33.729c-0.312,0-0.62,0.14-0.82,0.373L27.171,47.8l-5.68-6.648 c-0.2-0.234-0.508-0.376-0.82-0.377H9.822C7.134,40.774,5,38.736,5,36.118V11.722C5,9.104,7.148,7,9.822,7z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLateComplete);
export default __webpack_public_path__ + "static/media/pin-late-complete.518da8a4c3e28ba51e591d931b464072.svg";
export { ForwardRef as ReactComponent };